import { debounce } from 'lodash';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

export default function useVisibleElement(options?: IntersectionObserverInit) {
  const [element, setElement] = useState<any | null>(null);
  const [intersecting, setIntersecting] = useState(false);
  const observerRef = useRef<IntersectionObserver | null>(null);

  const debounceMemo = useMemo(() => debounce, []);

  const onIntersect = useCallback(([entry]: IntersectionObserverEntry[]) => {
    setIntersecting(entry.isIntersecting);
  }, []);

  useEffect(() => {
    if (!element) return;

    const observer = new IntersectionObserver(
      debounceMemo(entry => onIntersect(entry), 100),
      options,
    );

    observer.observe(element as Element);
    observerRef.current = observer;

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    };
  }, [onIntersect, element, debounceMemo, options]);

  return { intersecting, ref: element, setRef: setElement };
}
